export const OnlineBiddingStatus = {
    Disabled: 0,
    Enabled: 1,
    Bypassed: 2
};

export const OnlineBiddingStatusStrings = {
    0: 'Disabled',
    1: 'Enabled',
    2: 'Bypassed'
}; 